import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Select from 'react-select';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class SigtripAuditPermissions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: { message: '', type: '', status: 'open' },
      loaded: 0,
      groups: [],
      selectedGroup: null,
      activePermissions: [],
      permIdsText: '',
      matchMode: 'any', // 'any' | 'all'
      matchedGroups: [],
    };

    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleAlert = this.handleAlert.bind(this);
    this.onChangeGroup = this.onChangeGroup.bind(this);
    this.loadGroups = this.loadGroups.bind(this);
    this.fetchGroupPermissions = this.fetchGroupPermissions.bind(this);
    this.findGroupsByPermissions = this.findGroupsByPermissions.bind(this);
    this.exportGroupUsers = this.exportGroupUsers.bind(this);
    this.exportMatchedGroups = this.exportMatchedGroups.bind(this);
  }

  handleLoaded(state) {
    if (this.state.loaded !== 2) {
      this.setState({ loaded: state });
    }
  }

  handleAlert(message, type, status) {
    this.setState({ overlay: { message: message, type: type, status: status } });
  }

  componentDidMount() {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({ loaded: 2 }, this.loadGroups);
    }
  }

  loadGroups() {
    const header = this.refs.request_api.header('application/json');
    const self = this;
    Promise.resolve(header).then(function (value) {
      fetch(config.get('api_sigtrip') + '/grupos/permissao', { method: 'GET', mode: 'cors', headers: value })
        .then((response) => response.json())
        .catch((error) => { console.error(error); })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            const options = responseJson.data.map(function (g) { return { value: g.id, label: g.name }; });
            self.setState({ groups: options });
          }
        })
        .then(() => {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        });
    });
  }

  onChangeGroup(option) {
    this.setState({ selectedGroup: option, activePermissions: [] }, () => {
      if (option) { this.fetchGroupPermissions(option.value); }
    });
  }

  fetchGroupPermissions(groupId) {
    const header = this.refs.request_api.header('application/json');
    const self = this;
    self.handleAlert('', '', 'open');
    Promise.resolve(header).then(function (value) {
      fetch(config.get('api_sigtrip') + '/auditoria/grupo/' + groupId + '/permissoes', { method: 'GET', mode: 'cors', headers: value })
        .then((response) => response.json())
        .catch((error) => { console.error(error); })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            const perms = (responseJson.data || []);
            self.setState({ activePermissions: perms });
          }
        })
        .then(() => {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        });
    });
  }

  parsePermIds() {
    const parts = (this.state.permIdsText || '').split(/[,\s]+/).filter(function (t) { return t && !isNaN(parseInt(t)); });
    const ids = parts.map(function (t) { return parseInt(t); });
    const unique = Array.from(new Set(ids));
    return unique;
  }

  findGroupsByPermissions() {
    const permIds = this.parsePermIds();
    if (permIds.length === 0) { return; }
    const header = this.refs.request_api.header('application/json');
    const self = this;
    self.handleAlert('Carregando grupos...', 'info', 'open');
    const qs = 'permissions=' + encodeURIComponent(permIds.join(',')) + '&match=' + encodeURIComponent(this.state.matchMode);
    Promise.resolve(header).then(function (value) {
      fetch(config.get('api_sigtrip') + '/auditoria/permissoes/grupos?' + qs, { method: 'GET', mode: 'cors', headers: value })
        .then((r) => r.json())
        .catch((e) => { console.error(e); })
        .then((json) => {
          self.refs.request_api.validate(json, 'url');
          if (json && json.status === 'success') {
            self.setState({ matchedGroups: json.data || [] });
          }
        })
        .then(() => { self.handleAlert('', '', 'closed'); });
    });
  }

  exportGroupUsers(groupId) {
    const header = this.refs.request_api.header('application/json');
    const self = this;
    self.handleAlert('', '', 'open');
    Promise.resolve(header).then(function (value) {
      fetch(config.get('api_sigtrip') + '/exportar/usuarios/grupo/' + groupId, { method: 'GET', mode: 'cors', headers: value })
        .then((response) => response.json())
        .catch((error) => { console.error(error); })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            window.open(config.get('cdn_sigtrip') + '/tmp/' + responseJson.data);
          }
        })
        .then(() => { self.handleAlert('', '', 'closed'); });
    });
  }

  exportMatchedGroups() {
    const permIds = this.parsePermIds();
    if (permIds.length === 0) { return; }
    const header = this.refs.request_api.header('application/json');
    const self = this;
    self.handleAlert('', '', 'open');
    const qs = 'permissions=' + encodeURIComponent(permIds.join(',')) + '&match=' + encodeURIComponent(this.state.matchMode);
    Promise.resolve(header).then(function (value) {
      fetch(config.get('api_sigtrip') + '/auditoria/exportar/permissoes/grupos?' + qs, { method: 'GET', mode: 'cors', headers: value })
        .then((response) => response.json())
        .catch((error) => { console.error(error); })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success' && responseJson.data) {
            window.open(config.get('cdn_sigtrip') + '/tmp/' + responseJson.data);
          }
        })
        .then(() => { self.handleAlert('', '', 'closed'); });
    });
  }

  render() {
    const self = this;

    function GroupActions(cell, row) {
      return (
        <div className="btn-group">
          <button className="btn btn-sm btn-primary" onClick={() => self.exportGroupUsers(row.id)}>
            <i className="fa fa-download"></i> Exportar usuários do grupo
          </button>
        </div>
      );
    }

    return (
      <div>
        <Topo />
        <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <div className="container-fluid">
          <div className="conteudo">
            <h3 className="page-title">Auditoria de Permissões - SIGTRIP</h3>
            <hr/>

            <div className="row">
              <div className="col-md-6">
                <label>Grupo de permissões</label>
                <Select name="group" value={this.state.selectedGroup} onChange={this.onChangeGroup} options={this.state.groups} placeholder={'Selecione o grupo...'} />
              </div>
              <div className="col-md-6" style={{marginTop: '25px'}}>
                {this.state.selectedGroup ? (
                  <button className="btn btn-default" onClick={() => this.exportGroupUsers(this.state.selectedGroup.value)}>
                    <i className="fa fa-download"></i> Exportar usuários do grupo (arquivo)
                  </button>
                ) : ''}
              </div>
            </div>

            <hr/>
            <h4>Permissões ativas do grupo</h4>
            <BootstrapTable data={this.state.activePermissions} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Selecione um grupo'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
              <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} width='80'>ID</TableHeaderColumn>
              <TableHeaderColumn dataField="category" dataAlign="center" dataSort={true}>Categoria</TableHeaderColumn>
              <TableHeaderColumn dataField="subcategory" dataAlign="center" dataSort={true}>Subcategoria</TableHeaderColumn>
              <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true}>Nome</TableHeaderColumn>
            </BootstrapTable>

            <hr/>
            <h4>Grupos com permissões (IDs)</h4>
            <div className="row">
              <div className="col-md-8 form-group">
                <label>IDs de permissão (separados por vírgula ou espaço)</label>
                <input type="text" className="form-control" value={this.state.permIdsText} onChange={(e) => this.setState({permIdsText: e.target.value})} placeholder="Ex.: 194, 195, 196" />
              </div>
              <div className="col-md-4 form-group">
                <label>Modo de correspondência</label>
                <select className="form-control" value={this.state.matchMode} onChange={(e) => this.setState({matchMode: e.target.value})}>
                  <option value="any">Ao menos uma</option>
                  <option value="all">Todas</option>
                </select>
              </div>
            </div>
            <button className="btn btn-primary" onClick={this.findGroupsByPermissions}><i className="fa fa-search"></i> Consultar</button>
            {' '}
            <button className="btn btn-default" onClick={this.exportMatchedGroups}><i className="fa fa-download"></i> Exportar arquivo (grupos)</button>

            <div style={{marginTop: '15px'}}>
              <BootstrapTable data={this.state.matchedGroups} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Informe os IDs e consulte'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
                <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} width='80'>ID</TableHeaderColumn>
                <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true}>Grupo</TableHeaderColumn>
                <TableHeaderColumn dataField="matched_count" dataAlign="center" dataSort={true} width='160'>Permissões encontradas</TableHeaderColumn>
                <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={GroupActions} width='220'>Ações</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SigtripAuditPermissions;



// WEBPACK FOOTER //
// ./src/Components/Sigtrip/SigtripAuditPermissions.js